let routes = [
  {
    path: '/demande-reinscription-psychotherapeute',
    component: () => import('../views/DemandeReinscriptionPsychotherapeute.vue'),
    props: true
  },
  {
    path: '/demande-reinscription-psychotherapeute/:step',
    component: () => import('../views/DemandeReinscriptionPsychotherapeute.vue'),
    props: true
  }
]

export default routes;